import { ColDef, GridOptions, ValueFormatterParams } from 'ag-grid-enterprise';
import moment from 'moment';
import momenttz from 'moment-timezone';

import { DATE_FORMAT, DATE_TIME_FORMAT } from './date.constant';
import {
  CustomLoadingOverlayComponent,
  CustomNoRowsOverlayComponent
} from '../aggrid';

export const DEFAULT_PAGE_SIZE = 10;
export const PAGINATION_PAGE_SIZE = [10, 20, 50, 100];

//If we change below class we need to make sure we change theme in ag-grid scss setup under vendor.scss
export const AG_GRID_THEME_CLASS = 'ag-theme-alpine';

export const DATE_FORMATTER = (params: ValueFormatterParams) => {
  //const value = moment.unix(params.value);
  return moment(params.value).format(DATE_FORMAT);
};

export const DATE_FORMATTER_TIMEZONE = (params: ValueFormatterParams) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return momenttz(params.value).tz(timezone).format(DATE_FORMAT);
};

export const DATE_TIME_FORMATTER = (params: ValueFormatterParams) => {
  //const value = moment.unix(params.value);
  return moment(params.value).format(DATE_TIME_FORMAT);
};

export const DATE_TIME_FORMATTER_TIMEZONE = (params: ValueFormatterParams) => {
  const timezone = moment.tz.guess();
  return params.value
    ? momenttz.utc(params.value).tz(timezone).format(DATE_TIME_FORMAT)
    : '';
};

export const DEFAULT_COL_DEF: ColDef = {
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  suppressFloatingFilterButton: true,
  wrapText: true,
  cellStyle: { wordBreak: 'normal' },
  unSortIcon: true
};

export const LOADING_MESSAGE = 'loading data...';
export const NO_ROWS_MESSAGE = 'No rows to show';

export const DEFAULT_GRID_OPTIONS: GridOptions = {
  pagination: true,
  paginationPageSize: DEFAULT_PAGE_SIZE,
  paginationPageSizeSelector: PAGINATION_PAGE_SIZE,
  cellSelection: true,
  //loading overlay does not have any effect in case of SSRM
  loadingOverlayComponent: CustomLoadingOverlayComponent,
  loadingOverlayComponentParams: {
    loadingMessage: LOADING_MESSAGE
  },
  noRowsOverlayComponent: CustomNoRowsOverlayComponent,
  noRowsOverlayComponentParams: {
    noRowsMessage: NO_ROWS_MESSAGE
  },
  suppressContextMenu: true
};

export const AG_GRID_MAX_BLOCKS_IN_CACHE = 1;

export const AG_GRID_TOOL_TIP_SHOW_DELAY = 1000;

export const AG_GRID_BLOCK_LOAD_DEBOUNCE_MILLIS = 400;

export const AG_GRID_CELL_TEXT_ELLIPSIS = {
  'white-space': 'nowrap',
  'text-overflow': 'ellipsis',
  'overflow': 'hidden'
};

export const AG_GRID_CELL_CURSOR_POINTER = {
  'cursor': 'pointer'
};

export const AG_GRID_COLUMN_FILTER_DEBOUNCE = {
  debounceMs: 500
};

//badge types
export enum BADGE_TYPES {
  BADGE_SUCCESS = 'success',
  BADGE_WARNING = 'warning',
  BADGE_DANGER = 'danger'
}

//sort order constants
export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc',
  NULL = 'null' // For no sorting order
}

export const AG_GRID_HYPERLINK_TEXT_STYLE = {
  ...AG_GRID_CELL_CURSOR_POINTER,
  color: 'blue',
  'text-decoration': 'underline'
};

export const DEFAULT_GRID_SIDE_BAR_TOOL_PANEL = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true,
        suppressColumnFilter: true,
        suppressColumnSelectAll: true,
        suppressColumnExpandAll: true
      }
    }
  ]
};

export const FILTER_TYPES = {
  Set: 'set',
  Text: 'text',
  Number: 'number'
};

export enum ALERT_TYPES {
  'INFO' = 'info',
  'DANGER' = 'danger'
}
